import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarDays, Sparkles } from 'lucide-react';
import useEventCountdown from './events/useEventCountdown';
import { fetchEvents, eventPath } from '../utils/eventData';

const fmt = (p) => new Intl.NumberFormat('tr-TR').format(p || 0) + ' ₺';

const Card = ({ event }) => {
  const { status } = useEventCountdown(event.startISO, event.endISO);
  const [failed, setFailed] = useState(false);

  if (status === 'finished') return null;

  return (
    <Link
      to={eventPath(event)}
      data-testid="special-event-card"
      className="group block bg-white rounded-xl overflow-hidden border border-[#3D4A26]/25 hover:shadow-lg transition-all duration-300"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#2d3a1a]">
        <img
          src={failed ? event.heroImageFallback : event.heroImage}
          alt={event.heroImageAlt}
          onError={() => setFailed(true)}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-[#C8D843] text-[#1B1B1B] text-[11px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider">
          <Sparkles size={11} /> Özel Etkinlik
        </span>
      </div>
      <div className="p-4">
        <h3
          className="text-[15px] font-bold text-[#1B1B1B] mb-1.5 leading-tight line-clamp-2"
          style={{ fontFamily: 'DM Sans, sans-serif' }}
        >
          {event.name}
        </h3>
        <p className="text-sm text-gray-500 mb-2 inline-flex items-center gap-1.5">
          <CalendarDays size={13} className="text-[#3D4A26]" /> {event.dateLabel} · {event.durationLabel}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-base font-bold text-[#1B1B1B]">{fmt(event.price)}</span>
          <span className="text-xs font-semibold text-[#3D4A26]">Kontenjan {event.capacity} kişi</span>
        </div>
      </div>
    </Link>
  );
};

/** "Özel Etkinlik" badged card for the /turlar grid. */
const SpecialEventCard = () => {
  const [event, setEvent] = useState(null);

  useEffect(() => {
    fetchEvents().then((list) => setEvent(list[0] || null));
  }, []);

  if (!event) return null;
  return <Card event={event} />;
};

export default SpecialEventCard;
